export default "__VITE_ASSET__1vacaSZs__"